export const SEARCH_TYPE = 'favourites';
export const PAGE_HEADER_ID = 'favourites-page-header';
export const ALL_FAVOURITES_HEADING_ID = 'all-favourites-heading';
export const PAGE_TITLE = 'Favourites';
